import { render } from "./screen.vue?vue&type=template&id=c406dcb0&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"

import "../assets/screen/common.css?vue&type=style&index=0&id=c406dcb0&scoped=true&lang=css"
import "../assets/screen/index.css?vue&type=style&index=1&id=c406dcb0&scoped=true&lang=css"
import "./screen.vue?vue&type=style&index=2&id=c406dcb0&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c406dcb0"]])

export default __exports__